// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"127":"3464a71f","259":"21101b1b","343":"85a85ac6","548":"eee2764c","841":"731ab131","973":"63505f0c"}[chunkId] + ".chunk.js";
};